// extracted by mini-css-extract-plugin
export var filterIncDec = "_4s-0";
export var leftBorder = "_4s-1";
export var rightBorder = "_4s-2";
export var stringInput = "_4s-3";